// extracted by mini-css-extract-plugin
module.exports = {"list":"bannerlist-module--list--3SlNy","itemWrap":"bannerlist-module--item-wrap--3-ZUv"};